import AOS from 'aos'
import $ from 'jquery'
import './modal'
import './header'
import './reviews'
import './contact'
import '../../vendor/css/aos.css' // You can also use <link> for styles
window.addEventListener('DOMContentLoaded', () => {
    console.log('loadedx')
    AOS.init({
        easing: 'ease-in-out-quart',
        duration: 650,
        // delay: 1000,
    })
    // setTimeout(() => {
    $('.loader').hide({
        duration: 1000,
    })
    // }, 1000)
})
